"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { track } from "@vercel/analytics";
import { Camera, Search } from "lucide-react";
import { FreeSearchSheet } from "@/components/free-search-sheet";
import { requestFullscreen } from "@/lib/fullscreen";

export function FreeSearchCard() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <>
      <Card className="rounded-2xl border-dashed border-2 border-primary/30 bg-primary/5">
        <CardHeader className="pb-2">
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/15">
              <Search className="h-5 w-5 text-primary" />
            </div>
            <div className="min-w-0 flex-1">
              <CardTitle className="text-lg leading-tight">Try Design Search</CardTitle>
              <CardDescription className="mt-1 text-sm leading-relaxed">
                Take a photo of any object or drawing to find related design patents.
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="pt-0">
          <Button
            onClick={() => {
              track("free_search_opened");
              void requestFullscreen();
              setIsSearchOpen(true);
            }}
            variant="outline"
            className="h-12 w-full rounded-xl text-base font-medium border-primary/30 hover:bg-primary/10"
          >
            <Camera className="mr-2 size-7 shrink-0" strokeWidth={1.5} />
            Search Patents
          </Button>
        </CardContent>
      </Card>

      <FreeSearchSheet
        open={isSearchOpen}
        onOpenChange={setIsSearchOpen}
      />
    </>
  );
}
